import { createContext, ReactNode, useContext } from 'react'
import { useForm } from 'uniforms'

export const CiboAutoFormContext = createContext<{
  renderDisplay?: (config: {field:any, itemProps:any}) => ReactNode
  warnings?: Record<string, string>
  touch: (name: string) => void
  touched: Record<string, boolean>
  isFieldRequired?: (name: string) => boolean
}>({ touched: {}, touch: () => {} })

export const useCiboAutoForm = () => {
  const form = useForm()
  const context = useContext(CiboAutoFormContext)

  return { ...form, ...context }
}
